import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAction } from 'hooks';
import App, { AlertsBus } from 'modules/App';
import { RESET_PASSWORD_FORM } from '../../constants';
import * as actions from '../../actions';
import { useClearResetPassword } from '../../hooks';
import * as selectors from '../../selectors';
import Header from './Header';
import Info from './Info';
import CodeForm from './CodeForm';
import EmailForm from './EmailForm';
import SetPassword from './SetPassword';
const ResetPassword = ({ Layout, returnUrl })=>{
    const resetPasswordType = useSelector(selectors.resetPasswordType);
    const verifiedSignatureToken = useSelector(selectors.verifiedSignatureToken);
    const email = useSelector(App.selectors.formFieldValueSelector(RESET_PASSWORD_FORM, 'email'));
    const clearOtp = useAction(actions.clearOtp);
    const clearVerifiedSignatureToken = useAction(actions.setVerifiedSignatureToken, null);
    const clearResetPassword = useClearResetPassword();
    useEffect(()=>{
        clearOtp();
        clearVerifiedSignatureToken();
        return ()=>{
            clearResetPassword();
        };
    }, []);
    let Component;
    if (verifiedSignatureToken) {
        Component = SetPassword;
    } else if (resetPasswordType) {
        Component = resetPasswordType === 'code' ? CodeForm : ()=>null;
    } else {
        Component = EmailForm;
    }
    return /*#__PURE__*/ _jsx(Layout, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "pageContentBox pageContentBox--sm",
            children: [
                /*#__PURE__*/ _jsx(Header, {}),
                /*#__PURE__*/ _jsx(Info, {
                    returnUrl: returnUrl
                }),
                /*#__PURE__*/ _jsx(AlertsBus, {
                    className: "mb-5"
                }),
                /*#__PURE__*/ _jsx(Component, {
                    email: email,
                    returnUrl: returnUrl
                })
            ]
        })
    });
};
export default ResetPassword;
